'use client';

import { useEffect } from 'react';
import i18n from '@/i18n/config';
import { usePreferenceList } from '@/modules/preferences/queries';

export const LanguageSync = () => {
  const { data: preferences, isSuccess } = usePreferenceList();

  useEffect(() => {
    if (!isSuccess) return;

    const backendLang = preferences?.language;
    if (!backendLang) return;

    const currentLang = i18n.instance.language;

    if (backendLang !== currentLang) {
      i18n.instance.changeLanguage(backendLang).catch((e) => {
        console.error('changeLanguage failed', e);
      });
    }
  }, [isSuccess, preferences?.language]);

  return null;
};
